/**
 * Apply preset values to the form values.
 *
 * @param {Object<string, Object<string, any>>} presetValues - keyed by
 *     module UUID
 * @param {Object<string, { main: Object<string, any> }>} formValues -
 *     keyed by job name
 * @param {Object<string, Object>} jobNameToModuleVersion - map from job
 *     name to a ModuleVersion object (see MODEL_PROPTYPES.ModuleVersion)
 * @returns {Object<string, { main: Object<string, any> }>} a new object
 *     representing form values overriden by preset values for
 *     corresponding inputs. Same shape as formValues.
 */
export function applyPreset(presetValues, formValues, jobNameToModuleVersion) {
    const result = structuredClone(formValues);

    Object.entries(result).forEach(([jobName, jobValues]) => {
        const moduleVersion = jobNameToModuleVersion[jobName];
        if (!moduleVersion)
            throw new Error(
                `Module version not found for job name: ${jobName}`
            );

        const moduleUuid = moduleVersion.moduleUuid;
        const modulePresetValues = presetValues[moduleUuid];
        if (modulePresetValues) {
            Object.entries(modulePresetValues).forEach(([key, value]) => {
                if (key in jobValues.main) jobValues.main[key] = value;
            });
        }
    });

    return result;
}
